import InfoButton from "../InfoButton/InfoButton";

export default function LatestNewsItem(props) {
    return (
        <div className="flex flex-col gap-3 justify-between items-center py-4 border-b md:flex-row first-of-type:pt-0">
            <div className="flex flex-col gap-3 items-center md:flex-row">
                <img src={props.image} alt="" className="w-28 rounded-md" />
                <div className="flex flex-col gap-1 items-center md:items-start">
                    <h4 className="font-bold">{props.title}</h4>
                    <p className="text-gray-500 text-sm">{props.subtitle}</p>
                </div>
            </div>
            <InfoButton info={props.info} />
        </div>
    )
}
